import { render } from "./TermsAndConditionsPopup.vue?vue&type=template&id=1b705305"
import script from "./TermsAndConditionsPopup.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPopup.vue?vue&type=script&lang=js"
script.render = render

export default script